import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const SoundDisabled = (props: IconProps) => (
  <Icon width="63" height="62" viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M31.2595 61.1211C47.7595 61.1211 61.2595 47.6211 61.2595 31.1211C61.2595 14.6211 47.7595 1.12109 31.2595 1.12109C14.7595 1.12109 1.25952 14.6211 1.25952 31.1211C1.25952 47.6211 14.7595 61.1211 31.2595 61.1211Z"
      fill="white"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M40.4861 22.2899V36.4159C40.4861 38.8911 38.4735 40.9037 35.9983 40.9037C33.5356 40.9037 31.5105 38.8911 31.5105 36.4159C31.5105 33.9533 33.5356 31.9406 35.9983 31.9406C37.0484 31.9406 37.9859 32.3031 38.7485 32.9032V25.4652L27.2352 28.7404V38.8286C27.2352 41.3038 25.21 43.3164 22.7473 43.3164C20.2721 43.3164 18.2595 41.3038 18.2595 38.8286C18.2595 36.3659 20.2721 34.3533 22.7473 34.3533C23.7849 34.3533 24.7225 34.7158 25.485 35.3033V24.2526C25.485 22.4149 26.5976 20.9898 28.3603 20.5148L35.5858 18.5397C37.0484 18.1396 38.2859 18.2772 39.161 18.9522C40.0486 19.6148 40.4861 20.7398 40.4861 22.2899Z" />
    <path d="M19.4709 24.3438L41.394 39.9764" strokeWidth="2px" strokeLinecap="round" />
  </Icon>
);
